import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import QuotePrototype from '/react4xp/components/prototype/Quote'

type QuotePartData = {
	quote?: string
	attribution?: string
}

export const Quote = ({ data }: ComponentProps<PartData>) => {
	const { quote, attribution } = (data || {}) as QuotePartData

	// `isPart` makes the prototype component supply its own `container my-16`
	// wrapper. As a Part it is placed straight into a region, so nothing else
	// constrains its width.
	return <QuotePrototype quote={quote} attribution={attribution} isPart />
}
